/* eslint-disable max-len */
import { Component, Host, h, Prop, State, Watch, Element } from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

/**
 * Icons are used to either replace text or add additional dynamism and information to the text and page.
 * TODO: Ask why this page doesnt appear in UI Library
 */

export interface Icon {
  icon: string;
  variant: 'white' | 'colored';
  type: 'content' | 'system';
}

@Component({
  tag: 'ui-icon',
  styleUrl: 'ui-icon.scss',
  shadow: true,
})
export class UiIcon {
  @Element() el: HTMLElement;

  /**
   * Represents the icon's name, only available icons in the UI Icon Library are valid.
   */
  @Prop({ reflect: true }) icon: string;

  /**
   * Represents the icon's variant, relates to the color of the icon itself. The default is *colored*.
   */
  @Prop({ reflect: true }) variant: 'white' | 'colored' = 'colored';

  /**
   * System icons can be colored, content icons are precolored
   */
  @Prop({ reflect: true }) type: 'content' | 'system' = 'content';

  @State() svg: string;

  @Watch('icon')
  async getIcon() {
    // prevent network request if icon is not set
    if (!this.icon) {
      this.svg = '';
      return;
    }
    try {
      this.svg = await window.ui.services.svg.fetchSvg(this.icon, this.type);
    } catch {
      this.svg = '';
      // eslint-disable-next-line no-console
      console.log(`Could not load svg ${this.icon} from icon service.`);
    }
  }

  componentWillLoad() {
    this.getIcon();
  }

  render() {
    return (
      <Host>
        <div
          class={{ 'icon-container': true, white: this.variant === 'white' }}
          innerHTML={this.svg}
        ></div>
      </Host>
    );
  }
}

versionComponent(UiIcon);
